import RankSetter from './src/main';

/* istanbul ignore next */
RankSetter.install = function(Vue) {
  Vue.component(RankSetter.name, RankSetter);
};

export default RankSetter;
